import { Head } from '@inertiajs/react';

interface PageHeadProps {
  title?: string;
  description?: string;
  image?: string;
  canonicalUrl?: string;
  workspaceName?: string;
}

export function PageHead({
  title,
  description,
  image,
  canonicalUrl,
  workspaceName
}: PageHeadProps) {
  const pageTitle = title || workspaceName || '';
  const pageDescription = description || '';

  return (
    <Head title={pageTitle}>
      {canonicalUrl ? <link head-key="canonical" rel="canonical" href={canonicalUrl} /> : null}
      <meta head-key="description" name="description" content={pageDescription} />
      <meta head-key="og:title" property="og:title" content={pageTitle} />
      <meta head-key="og:description" property="og:description" content={pageDescription} />
      {canonicalUrl ? <meta head-key="og:url" property="og:url" content={canonicalUrl} /> : null}
      <meta head-key="og:type" property="og:type" content="website" />
      {image ? <meta head-key="og:image" property="og:image" content={image} /> : null}
      <meta head-key="twitter:card" name="twitter:card" content="summary_large_image" />
      <meta head-key="twitter:title" name="twitter:title" content={pageTitle} />
      <meta head-key="twitter:description" name="twitter:description" content={pageDescription} />
      {image ? <meta head-key="twitter:image" name="twitter:image" content={image} /> : null}
    </Head>
  );
}
